// BackofficePoInvoiceMatch.js
import React from "react";
import {
  Grid,
  Paper,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  Divider,
  Link
} from "@material-ui/core";
import axios from "axios";
import { withStyles } from "@material-ui/core/styles";
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

const styles = (theme) => ({
  page: {
    minHeight: "100vh",
    background: "#f6f8fb",
    padding: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1)
    }
  },
  container: {
    maxWidth: 1000,
    margin: "0 auto"
  },
  card: {
    borderRadius: 14,
    border: "1px solid #e5e7eb",
    padding: theme.spacing(2),
    background: "#fff"
  },
  header: {
    marginBottom: theme.spacing(2)
  },
  title: {
    fontWeight: 900,
    color: "#0f2c4d"
  },
  subtitle: {
    color: "#51606f"
  },
  select: {
    background: "#fff"
  },
  linkBox: {
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    background: "#fbfdff",
    padding: theme.spacing(1.5)
  },
  linkLabel: {
    fontWeight: 800,
    color: "#1f3b57",
    marginBottom: 6
  },
  linkRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap"
  },
  linkHint: {
    color: "#6b7280",
    fontSize: 12
  },
  primaryBtn: {
    borderRadius: 12,
    textTransform: "none",
    fontWeight: 800,
    background: "#1e4679",
    color: "#fff",
    paddingLeft: 18,
    paddingRight: 18
  },
  secondaryBtn: {
    borderRadius: 12,
    background: "#1e4679",
    textTransform: "none",
    fontWeight: 800
  },
  disabledNote: {
    marginTop: theme.spacing(1),
    color: "#6b7280",
    fontSize: 12
  },
  divider: {
    margin: `${theme.spacing(2)}px 0`
  }
});

class BackofficePoInvoiceMatch extends React.Component {
  state = {
    // placeholder list from backend
    pos: [],
    selectedPoId: "",
    selectedPo: null,

    invoicePdfUrl: "", // stored/linked invoice PDF (optional)
    invoiceFile: null, // upload file (optional)
    notes: "",
    saving: false
  };

  componentDidMount() {
    this.loadDeliveredPOs();
  }

  loadDeliveredPOs = async () => {
    let allDeliveredPO = (await axios
      .get("/purchaseOrder/delivered")
      .catch(function(error) {
        return error.response;
      })).data;

    let items = []

    if(allDeliveredPO && allDeliveredPO.data && allDeliveredPO.data.length > 0) {
      allDeliveredPO = allDeliveredPO.data;

      for (var i = 0; i < allDeliveredPO.length; i++) {
        console.log("allDeliveredPO", allDeliveredPO[i])
        items.push({
          id: allDeliveredPO[i].id,
          po_number: allDeliveredPO[i].po_number,
          status: allDeliveredPO[i].status,
          po_pdf_url: process.env.REACT_APP_BASE_URL + "po/" + allDeliveredPO[i].po_number + ".pdf",
          invoice_pdf_url: process.env.REACT_APP_BASE_URL + "invoice/" + "NT 13.01.26  2625029.pdf"
        });
      } 
    }

    this.setState({ pos: items });
  };

  handleSelectPO = (e) => {
    const selectedPoId = e.target.value;
    const selectedPo = this.state.pos.find((p) => String(p.id) === String(selectedPoId)) || null;

    this.setState({
      selectedPoId,
      selectedPo,
      // if backend already has invoice link, load it
      invoicePdfUrl: selectedPo?.invoice_pdf_url || "",
      invoiceFile: null,
      notes: ""
    });
  };

  handleInvoiceUrlChange = (e) => {
    this.setState({ invoicePdfUrl: e.target.value });
  };

  handleInvoiceFileChange = (e) => {
    const file = e.target.files?.[0] || null;
    this.setState({ invoiceFile: file });
  };

  // ✅ Placeholder: save matching result (PO id + invoice link/file + notes)
  handleSaveMatch = async () => {
    const { selectedPo, invoicePdfUrl, invoiceFile, notes } = this.state;
    if (!selectedPo) return;

    this.setState({ saving: true });
    try {
      // Option A: if you only store invoice link
      // await fetch(`/api/backoffice/po/${selectedPo.id}/match-invoice`, { ... })

      // Option B: upload invoice file (FormData)
      // const form = new FormData();
      // form.append("invoice_pdf_url", invoicePdfUrl);
      // if (invoiceFile) form.append("invoice_file", invoiceFile);
      // form.append("notes", notes);
      // await fetch(`/api/backoffice/po/${selectedPo.id}/match-invoice`, { method:"POST", body: form });

      // demo delay
      await new Promise((r) => setTimeout(r, 600));

      alert("Saved invoice matching (placeholder).");
    } catch (err) {
      alert(err?.message || "Failed to save match.");
    } finally {
      this.setState({ saving: false });
    }
  };

  renderLinkBlock(label, url, emptyText) {
    const safeUrl = (url || "").trim();
    return (
      <div style={{ marginBottom: 12 }}>
        <div style={{ fontWeight: 800, color: "#1f3b57", marginBottom: 6 }}>{label}</div>
        <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          {safeUrl ? (
            <>
              <Link href={safeUrl} target="_blank" rel="noopener noreferrer">
                <Typography variant="body2" style={{ color: "blue", fontSize: 12 }}>
                  {safeUrl}
                </Typography>
              </Link>
            </>
          ) : (
            <Typography variant="body2" style={{ color: "#6b7280", fontSize: 12 }}>
              {emptyText}
            </Typography>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { classes } = this.props;
    const { pos, selectedPoId, selectedPo, invoicePdfUrl, saving } = this.state;

    return (
      <div className={classes.page}>
        <div className={classes.container}>
          <div className={classes.header}>
            <Typography variant="h5" className={classes.title}>
              PO vs Invoice Matching
            </Typography>
            <Typography variant="body2" className={classes.subtitle}>
              Backoffice tool to attach supplier invoice to a delivered PO.
            </Typography>
          </div>

          <Paper elevation={0} className={classes.card}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="po-select-label">Select Delivered PO</InputLabel>
                  <Select
                    labelId="po-select-label"
                    value={selectedPoId}
                    onChange={this.handleSelectPO}
                    label="Select Delivered PO"
                    className={classes.select}
                    disabled={!pos.length}
                  >
                    {pos.map((p) => (
                      <MenuItem key={p.id} value={String(p.id)}>
                        {p.po_number} — {p.status}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {!pos.length && (
                  <div className={classes.disabledNote}>
                    No delivered PO available (placeholder). Connect your backend list here.
                  </div>
                )}
              </Grid>

              <Grid item xs={12} md={6} style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  className={classes.secondaryBtn}
                  onClick={this.loadDeliveredPOs}
                >
                  Refresh
                </Button>
                <Button
                  variant="contained"
                  className={classes.primaryBtn}
                  disabled={!selectedPo || saving}
                  onClick={this.handleSaveMatch}
                >
                  {saving ? "Saving..." : "Save Match"}
                </Button>
              </Grid>
            </Grid>

            <Divider className={classes.divider} />

            <div className={classes.linkBox}>
              {this.renderLinkBlock(
                "Delivered PO PDF",
                selectedPo?.po_pdf_url,
                selectedPo ? "No PO PDF link found for this PO." : "Select a PO to see the PDF link."
              )}

              {this.renderLinkBlock(
                "Invoice PDF",
                selectedPo?.invoice_pdf_url || invoicePdfUrl,
                selectedPo ? "No invoice PDF attached yet." : "Select a PO to see/add invoice link."
              )}
            </div>

            <Divider className={classes.divider} />

            <Grid container spacing={2}>
              <Grid item xs={12} md={7}>
                <TextField
                  label="Invoice PDF URL (optional)"
                  variant="outlined"
                  fullWidth
                  value={invoicePdfUrl}
                  onChange={this.handleInvoiceUrlChange}
                  disabled={!selectedPo}
                  placeholder="https://.../supplier-invoice.pdf"
                />
                <Typography style={{ color: "#6b7280", fontSize: 12, marginTop: 6 }}>
                  If you store invoices in your system, you can paste a link here (or upload below).
                </Typography>
              </Grid>

              <Grid item xs={12} md={5}>
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  <input
                    type="file"
                    accept="application/pdf"
                    onChange={this.handleInvoiceFileChange}
                    disabled={!selectedPo}
                  />
                  <Typography style={{ color: "#6b7280", fontSize: 12 }}>
                    Upload invoice PDF (optional).
                  </Typography>
                </div>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Notes / Matching Result"
                  variant="outlined"
                  fullWidth
                  multiline
                  minRows={3}
                  value={this.state.notes}
                  onChange={(e) => this.setState({ notes: e.target.value })}
                  disabled={!selectedPo}
                  placeholder="Example: Invoice has extra items: ... / Price differs on item X ..."
                />
              </Grid>
            </Grid>
          </Paper>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(BackofficePoInvoiceMatch);
